<template>
  <div class="privacy-policy body-wrap boxed-container">
    <div class="container-herohire">
      <Header />
      <PolicyHeader/>
      <PolicyText/>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import PolicyHeader from '../components/PrivacyPolicy/PolicyHeader';
  import Footer from '../components/GeneralViews/Footer';
  import PolicyText from '../components/PrivacyPolicy/PolicyText';
  import Header from '../components/Homepage/Header';

  export default {
    name: "PrivacyPolicy",
    components: {Header, PolicyText, Footer, PolicyHeader}
  }
</script>

<style scoped>

</style>
